import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { fetchArticlesCash, fetchFilials, } from '../../action/handbook';
import Loader from '../utils/Loader';
import Portlet from '../utils/Portlet';
import ErrorContainer from '../utils/ErrorContainer';
import { optionsMovementCash, roleId, urls } from '../../constants/app';
import { setUIvisible } from '../../action/UImobile';
import HeadMobileActionMenu from '../utils/HeadMobileActionMenu';
import { fetchWorkingShift, setTypeMovementCash, setCassaFilters, setDetailArticle, deleteArticleWorkingShift, setWorkingShift, getXReport, initLMMark, getStatusLM, deleteWorkingShift, recalculationWorkingShift } from '../../action/cassa';
import Select from 'react-select';
import moment from 'moment';
import '../../styles/cassa.css'
import WorkingShiftArticlesTable from './WorkingShiftArticlesTable';
import { setActiveModalAction } from '../../action';
import DateInput from '../utils/DateInput';
import WorkingShiftsTable from './WorkingShiftsTable';
import swal from 'sweetalert';
import request from '../../action/utils/request';
import { parseNumToFixed } from '../../utils/common';
import { isEmpty } from 'lodash';
import { utils, writeFileXLSX } from 'xlsx';
import ErrorBoundary from '../utils/ErrorBoundary';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class WorkingShiftList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            articlesFilters: {
                name: null,
                typeMovementCash: null,
                typeTransaction: null
            },
            revenue: {
                cash: 0,
                noncash: 0,
                loadingRevenue: false
            },
            renderInitLM: false,
            unfiscalized: [],
            openDescription: false,
        };
    }
    
    onDelete = (id) => {
        return swal({
            title: "Удаление смены",
            text: `Вы уверены, что хотите удалить смену ${id}? Это действие необратимо.`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) this.props.deleteWorkingShift(id);
        });
    }

    onRecalculation = (item) => {
        return swal({
            title: "Перерасчет смены",
            text: `Вы уверены, что хотите пересчитать смену ${item.id}? Это действие необратимо.`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Пересчитать"],
        }).then((willRecalculation) => {
            if (willRecalculation) this.props.recalculationWorkingShift(item);
        });
    }

    setArticleFilters = (field) => (e) =>  {
        const data = {...this.state.articlesFilters};

        if (e.value) {
            data[field] = e;
        } else {
            data[field] = null;
        }

        if(field === 'typeMovementCash' && e.value === 'incasso') {
            data.typeTransaction = {value: 'cash', label: 'Наличные'};
        }

        this.setState({ articlesFilters: data });
    }

    componentDidMount() {
        const getData = async () => {
            await Promise.all([
                this.props.fetchFilials(null),
                this.props.fetchArticlesCash(true),
                this.getStatusLM(),
            ]);

            this.props.fetchWorkingShift();
            this.props.setUIvisible(true, true);
            this.updateRevenue();
        }

        getData();

        if(this.props.role === roleId.cashier) this.setArticleFilters('typeTransaction')({value: 'cash', label: 'Наличные'});
        if(this.props.role === roleId.accountant || this.props.role === roleId.chiefAccountant) this.setArticleFilters('typeTransaction')({value: 'noncash', label: 'Безнал. '});
    }

    componentWillUnmount(){
        const { filters } = this.props;
        let updated = {
            ...filters
        }

        updated.createdEndDate = null;
        updated.createdStartDate = null;

        this.props.setCassaFilters(updated);
    }

    async componentDidUpdate(prevProps) {
        if (!prevProps.workingShift || (prevProps.workingShift && this.props.workingShift && this.props.workingShift.id !== prevProps.workingShift.id)) {
            this.updateRevenue();
        }
        if (prevProps.filters.point !== this.props.filters.point || prevProps.userPoints !== this.props.userPoints) await this.getStatusLM();
    }

    onAddArticle = (type) => {
        this.props.setTypeMovementCash(type)
        this.props.setActiveModalAction({ field: 'workingShiftAddArticles', value: true })
    }

    onEditArticle = (article) => {
        this.props.setDetailArticle(article)
        this.props.setTypeMovementCash(article.typeMovementCash)
        this.props.setActiveModalAction({ field: 'workingShiftAddArticles', value: true })
    }

    deleteArticle = (article) => {
        const text = `Внимание! Вы удаляете статью ${article.name} на сумму ${parseFloat(article.sum).toFixed(2)} от ${article.created_at}. Это действие нельзя отменить!`
        return swal({
            title: "Удаление статьи",
            text: text,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willClose) => {
            if (willClose) {
                this.props.deleteArticleWorkingShift(article);
            }
        });
    }

    getStatusLM = async () => {
        const getPoint = this.checkPointValue();
        const id = (getPoint && getPoint.value) ? getPoint.value : null;
        const point = id ? this.props.filials.find((item) => item.id === id) : null;

        if (!point) return false;
        const result = await this.props.getStatusLM(point);
        this.setState({ renderInitLM: !result});
    }

    initLMMark = async () => {
        const getPoint = this.checkPointValue();
        const id = getPoint.value ? getPoint.value : null;
        const point = id ? this.props.filials.find((item) => item.id === id) : null;

        if(!point) {
            return swal({
                title: 'Ошибка',
                text: 'Не обнаружен филиал.',
                icon: 'error',
                buttons: ['OK']
            });
        }

        const result = await this.props.initLMMark(point);

        if(result.error || result.error_message || !result) {
            return swal({
                title: 'Ошибка инициализации',
                text: `${result.error && result.error.code ? `Код ошибки: ${result.error.code}, ` : ''}${result.error_message ? ` ${result.error_message}` : ''}`,
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        this.setState({ renderInitLM: false});
        return swal({
            title: result.message ? result.message : 'Инициализация успешна.',
            icon: "success",
            button: "Ок",
        });
    }

    onOpenModal = () => {
        const id = (this.props.workingShift && !this.props.workingShift.closed_at) ? this.props.workingShift.id : null;
        const point = this.checkPointValue();

        if(!point) {
            return swal({
                title: 'Ошибка',
                text: 'Не обнаружен филиал.',
                icon: 'error',
                button: 'Oк'
            });
        }

        return this.props.setActiveModalAction({ field: 'workingShiftModal', value: { id, point } });
    }

    handleXReport = async () => {
        const point = this.checkPointValue();
        try {
            const result = await this.props.getXReport(point);
            if(result.error || !result || !result.message) throw new Error(result.error);
            
            return swal({
                title: result.message ? result.message : '',
                icon: "success",
                button: "Ок",
            });
        } catch(error) {
            return swal({
                title: "Ошибка получения X-отчета",
                text: `${error.code ? `Код ошибки: ${error.code} ` : ''}${error.description ? `, ${error.description}` : ''}`,
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }
    }

    setFilters = (field) => (data) => {
        const { filters } = this.props;
        let updated = {
            ...filters,
            [field]: data
        }

        if(data.value === null) {
            updated = {
                ...filters,
                [field]: null
            }
        }

        let articlesFilters = { name: null, typeMovementCash: null };
        
        if(this.props.role === roleId.cashier) articlesFilters.typeTransaction = { value: 'cash', label: 'Наличные' };
        if(this.props.role === roleId.accountant || this.props.role === roleId.chiefAccountant) articlesFilters.typeTransaction = { value: 'noncash', label: 'Безнал. ' };
        
        this.setState({ articlesFilters: articlesFilters });

        updated.createdEndDate = null;
        updated.createdStartDate = null;

        this.props.setCassaFilters(updated);
        this.props.fetchWorkingShift();   
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props;

        const updated = {
            ...filters,
            [field]: date,
        };

        if (field === 'createdStartDate') {
            updated.createdEndDate = moment(date).endOf('month').toDate()
        }

        if(updated.createdStartDate && moment(updated.createdEndDate) < moment(updated.createdStartDate)) {
            updated.createdStartDate = moment(updated.createdEndDate).startOf('month').toDate();
        }
        
        this.props.setCassaFilters(updated);
    }

    onSearchDate = () => {
        if(this.props.list && this.props.list.length > 0) {
            const { filters } = this.props;
            const updated = {
                ...filters,
                createdEndDate: null,
                createdStartDate: null,
            };
            this.props.setCassaFilters(updated);
        }

        this.setState({
            articlesFilters: {
                name: null,
                typeMovementCash: null,
                typeTransaction: null
            }
        });

        this.props.fetchWorkingShift();
    }

    renderAdress(item) {
        return `${item.city.name}, ${item.street}, ${item.house}`;
    }

    onRefresh = () => {
        this.props.fetchWorkingShift();
    }

    checkPointValue() {
        if (this.props.filters.point) return this.props.filters.point;
        if(!this.props.filters.point && (this.props.filials.length === 0 || !this.props.filials[0])) return null;
        if(this.props.filials[0]) return {value: this.props.filials[0].id, label: this.renderAdress(this.props.filials[0])};
        return null;
    }

    checkDataAtol() {
        let point = null;

        if (this.props.filters.point) point = this.props.filials.find((item) => item.id === this.props.filters.point.value);

        if(!this.props.filters.point && this.props.filials[0]) point = this.props.filials[0];

        if(point && point.atolData && point.atolData.activate)
            return true;

        return false;
    }

    disableInputTypeTransaction(){    
        if(this.props.loadingArticles || this.props.loadingFilials) return false;
        if(this.state.articlesFilters.typeMovementCash && this.state.articlesFilters.typeMovementCash.value === 'incasso') return false;
        if([roleId.cashier, roleId.accountant, roleId.chiefAccountant].includes(this.props.role)) return false;
        return true;
    }

    updateRevenue = async () => {
        const { workingShift } = this.props;
        if (!workingShift || workingShift.closed_at) return;

        try {
            this.setState({ loadingRevenue: true });
            const revenue = await this.renderRevenueOpenedShift();
            const cash = revenue.cash;
            const noncash = revenue.noncash;
            
            this.setState({
                revenue: { cash, noncash },
                loadingRevenue: false,
            });
        } catch (error) {
            this.setState({ loadingRevenue: false });
            console.error('Ошибка при расчете выручки:', error);
        }
    };

    async renderRevenueOpenedShift() {
        const shift = this.props.workingShift;
    
        const calculateTotal = (data, articles, paymentMethod) => {
            if (!Array.isArray(data)) return 0;

            let total = 0;
            
            const ordersTotal = data.reduce((acc, item) => {                
                if (item.payment === paymentMethod) {
                    return acc + parseFloat(item.totalPrice || 0);
                } else {
                    return acc;
                }
            }, 0).toFixed(2);

            if (ordersTotal) total += parseFloat(ordersTotal);
     
            if (!articles || articles.length === 0) return total;

            const filteredArticles = articles.filter((article) => {
                if (paymentMethod === 'terminal') {
                    if (article.typeTransaction === 'noncash') return true;
                    return false;
                } else {
                    if (article.typeTransaction === 'cash') return true;
                    return false;
                }
            });

            if (!filteredArticles || filteredArticles.length === 0) return total;

            const articlesSum = filteredArticles.reduce((acc, item) => {
                if (item.sum) return acc + parseFloat(item.sum);
                return acc;
            }, 0).toFixed(2);

            if (articlesSum) total -= parseFloat(articlesSum);

            return total;
        };      

        const threeMonthsAgo = moment().subtract(3, 'months');
        const isRecentShift = moment(shift.created_at).isAfter(threeMonthsAgo);        
        const type = isRecentShift ? 'orders' : 'archive';
        
        const dataParams = {
            workingShiftId: shift.id || null,
            payments: ['cash', 'terminal'],
            type
        };

        const ordersData = await request({ method: 'post', url: `${urls.workingShift}/ordersList`, data: dataParams });
        const unfiscalized = (ordersData || []).filter(order => {
            return order.fiscalized !== true
        })
        this.setState({ unfiscalized: unfiscalized });
        const articlesRefundRevenue = (shift.articlesCashes || []).filter((article) => article.typeMovementCash === 'refund_revenue');
        return { cash: calculateTotal(ordersData || [], articlesRefundRevenue, 'cash'), noncash: calculateTotal(ordersData || [], articlesRefundRevenue, 'terminal')};
    }

    renderFinalBalanceOpenedShift(field, shiftData) {
        const shift = shiftData ? shiftData : this.props.workingShift;
        const { revenue } = this.state;

        if (field === 'cash') {
            return (parseFloat(shift.initialBalanceCash || 0) + parseFloat(revenue.cash || 0) + parseFloat(shift.depositingCash || 0) - parseFloat(shift.withdrawalCash || 0) + parseFloat(shift.incassoCash || 0)).toFixed(2);
        } else {
            return (parseFloat(shift.initialBalanceNoncash || 0) + parseFloat(revenue.noncash || 0) + parseFloat(shift.depositingNoncash || 0) - parseFloat(shift.withdrawalNoncash || 0)).toFixed(2);
        }
    }

    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Смена</h3>
                    <button className="btn btn-secondary btn-icon">
                        <i onClick={this.onRefresh} className='la la-refresh'/>
                    </button>
                    {this.props.workingShift && this.props.workingShift.errorKKT && <span className='kt-inbox__label kt-badge  kt-badge--danger kt-badge--bold kt-badge--inline'> При открытии\закрытии смены в CRM произошла ошибка ККТ </span>}
                    <div className="kt-subheader__group" id="kt_subheader_search">                       
                    </div>
                </div>
                {
                    window.innerWidth > 1024 && this.checkPointValue() && this.checkDataAtol() && (
                        <div className="kt-subheader__toolbar">
                            {this.state.renderInitLM && <button onClick={this.initLMMark} className='btn btn-primary'>
                                Инициализировать ЛМ ЧЗ
                            </button>}
                            <button onClick={this.onOpenModal} className={`btn ${(this.props.workingShift && !this.props.workingShift.closed_at) ? 'btn-danger' : 'btn-success'} btn-icon-sm`}>
                                {(this.props.workingShift && !this.props.workingShift.closed_at) ? 'Закрыть смену' : 'Открыть смену'}
                            </button>
                            {(this.props.workingShift && !this.props.workingShift.closed_at) && (
                            <>
                                <button onClick={() => this.onAddArticle('income')} className='btn btn-dark btn-icon-sm'>
                                    + Внесение
                                </button>
                                {/*this.props.role !== roleId.accountant && this.props.role !== roleId.chiefAccountant && 
                                    <button onClick={() => this.onAddArticle('incasso')} className='btn btn-dark btn-icon-sm'>
                                        Инкассация
                                    </button>
                                */}
                                <button onClick={() => this.onAddArticle('expenditure')} className='btn btn-dark btn-icon-sm'>
                                    - Изъятие
                                </button>
                                {this.props.workingShift && !this.props.workingShift.closed_at &&
                                <button className='btn btn-primary' onClick={this.handleXReport}>
                                    X-отчет
                                </button>
                                }
                            </>
                            )}                        
                        </div>
                    )
                }
                </div>
            </div>
        );
    }

    onExportBalance = () => {
        const { list, filters } = this.props;
        const { revenue } = this.state;

        if (isEmpty(list)) return swal({
            title: "Нет данных для экспорта",
            icon: "error",
            button: "Ок",
        });

        const getRevenueShift = (shift, field) => {
            if (!shift.closed_at) {
                if (revenue[field] != null) return parseNumToFixed(revenue[field]) || 0;
                return '-';
            }

            if (field === 'cash') {
                if (shift.revenueCash != null) return parseNumToFixed(shift.revenueCash) || 0;
                return '-';
            } else {
                if (shift.revenueNoncash != null) return parseNumToFixed(shift.revenueNoncash) || 0;
                return '-';
            }
        }

        const getFinalBalanceShift = (shift, field) => {
            if (shift.closed_at) {
                if (field === 'cash') {
                    if (shift.finalBalanceCash != null) return parseNumToFixed(shift.finalBalanceCash) || 0;
                    return '-';
                } else {
                    if (shift.finalBalanceNoncash != null) return parseNumToFixed(shift.finalBalanceNoncash) || 0;
                    return '-';
                }
            }

            return this.renderFinalBalanceOpenedShift(field, shift);
        }

        const exportData = list.map((shift) => {
            return {
                'Открытие (дата)': shift.opened_at ? moment(shift.opened_at).format('DD.MM.YYYY HH:mm:ss') : '-',
                'Открытие (пользователь)': shift.shiftOpener ? shift.shiftOpener : '-',
                'Закрытие (дата)': shift.closed_at ? moment(shift.closed_at).format('DD.MM.YYYY HH:mm:ss') : '-',
                'Закрытие (пользователь)': shift.shiftCloser ? shift.shiftCloser : '-',
                'Начальный остаток (нал.)': shift.initialBalanceCash != null ? parseNumToFixed(shift.initialBalanceCash) || 0 : '-',
                'Начальный остаток (безнал.)': shift.initialBalanceNoncash != null ? parseNumToFixed(shift.initialBalanceNoncash) || 0 : '-',
                'Выручка (нал.)': getRevenueShift(shift, 'cash'),
                'Выручка (безнал.)': getRevenueShift(shift, 'noncash'),
                'Внесение (нал.)': shift.depositingCash != null ? parseNumToFixed(shift.depositingCash) || 0 : '-',
                'Внесение (безнал.)': shift.depositingNoncash != null ? parseNumToFixed(shift.depositingNoncash) || 0 : '-',
                'Изъятие (нал.)': shift.withdrawalCash != null ? parseNumToFixed(shift.withdrawalCash) || 0 : '-',
                'Изъятие (безнал.)': shift.withdrawalNoncash != null ? parseNumToFixed(shift.withdrawalNoncash) || 0 : '-',
                'Итог (нал.)': getFinalBalanceShift(shift, 'cash'),
                'Итог (безнал.)': getFinalBalanceShift(shift, 'noncash'),
            }
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        const periodText = `с ${moment(filters.createdStartDate).format('DD.MM.YYYY')} по ${moment(filters.createdEndDate).format('DD.MM.YYYY')}`;
        const point = this.checkPointValue();
        const pointText = (point && point.label) ? point.label : ''; 
        utils.book_append_sheet(wb, ws, 'Балансы смен');
        writeFileXLSX(wb, `Балансы смен ${pointText} ${periodText}.xlsx`);
    }

    onExportArticles = () => {
        const { list, filters } = this.props;

        if (isEmpty(list)) return swal({
            title: "Нет данных для экспорта",
            icon: "error",
            button: "Ок",
        });

        const listWithArticles = list.filter((item) => !isEmpty(item.articlesCashes));

        if (isEmpty(listWithArticles)) return swal({
            title: "Нет данных для экспорта",
            text: 'Не найдены смены с операциями.',
            icon: "error",
            button: "Ок",
        });

        const renderType = (typeMovementCash) => {
            if (typeMovementCash === 'incasso') return 'Инкассация';
            if (typeMovementCash === 'expenditure') return 'Изъятие';
            if (typeMovementCash === 'income') return 'Внесение';
            return;
        }

        const exportData = listWithArticles.flatMap((shift) => {
            return shift.articlesCashes.map((article) => {
                return {
                    'Открытие смены (дата)': shift.opened_at ? moment(shift.opened_at).format('DD.MM.YYYY HH:mm:ss') : '-',
                    'Открытие смены (пользователь)': shift.shiftOpener ? shift.shiftOpener : '-',
                    'Закрытие смены (дата)': shift.closed_at ? moment(shift.closed_at).format('DD.MM.YYYY HH:mm:ss') : '-',
                    'Закрытие смены (пользователь)': shift.shiftCloser ? shift.shiftCloser : '-',
                    'Время создания': article.created_at || '-',
                    'Пользователь': article.author || '-',
                    'Статья': article.name,
                    'Тип транзакции': article.typeTransaction === 'cash' ? 'Наличные' : 'Безнал.',
                    'Тип операции': renderType(article.typeMovementCash),
                    'Сумма': article.sum != null ? parseNumToFixed(article.sum) || 0 : '-',
                    'Примечание': article.comment || '-',
                }
            });
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        const periodText = `с ${moment(filters.createdStartDate).format('DD.MM.YYYY')} по ${moment(filters.createdEndDate).format('DD.MM.YYYY')}`;
        const point = this.checkPointValue();
        const pointText = (point && point.label) ? point.label : ''; 
        utils.book_append_sheet(wb, ws, 'Операции смен');
        writeFileXLSX(wb, `Операции смен ${pointText} ${periodText}.xlsx`);
    }

    renderFiltersBlock(){        
            return(
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginTop: '10px', gap: '10px'}}>            
                    <div style={{ width: 250 }}>
                        <Select
                        isLoading={this.props.loadingFilials}
                        isDisabled={this.props.loadingFilials}
                        value={this.checkPointValue()}
                        closeMenuOnSelect={true}
                        onChange={this.setFilters('point')}
                        options={this.props.filials.map((el) => ({ value: el.id, label: this.renderAdress(el) }))}
                        placeholder="Филиал"
                        noOptionsMessage={() => 'Нет филиалов'}
                        />
                    </div>
                    {this.props.workingShift && !this.props.workingShift.closed_at && (window.innerWidth > 1024 || this.props.UImobile.openFilters) &&
                        <>
                            <div style={{ width: 150 }}>
                                <Select
                                isLoading={this.props.loadingArticles || this.props.loadingFilials}
                                isDisabled={this.props.loadingArticles || this.props.loadingFilials}
                                value={this.state.articlesFilters.name}
                                closeMenuOnSelect={true}
                                onChange={this.setArticleFilters('name')}
                                options={[
                                    {value: null, label: 'Все статьи'},
                                    ...this.props.articlesCash.sort((a, b) => {
                                        if (a.name < b.name) return -1;
                                        if (a.name > b.name) return 1;
                                        return 0;
                                        })
                                        .filter((el) => {
                                        let check = true;

                                        if (this.state.articlesFilters.typeMovementCash) {
                                            check = check && (el.typeMovementCash === this.state.articlesFilters.typeMovementCash.value);
                                        }

                                        if (this.state.articlesFilters.typeTransaction) {
                                            check = check && (el.typeTransaction === this.state.articlesFilters.typeTransaction.value);
                                        }

                                        return check;
                                        })
                                        .map(el => ({
                                        value: el.id,
                                        label: el.name
                                    }))
                                ]}
                                placeholder="Статья"
                                noOptionsMessage={() => 'Нет статей'}
                                />
                            </div>
                            <div style={{ width: 150 }}>
                                <Select
                                isLoading={this.props.loadingArticles || this.props.loadingFilials}
                                isDisabled={!this.disableInputTypeTransaction()}
                                value={this.state.articlesFilters.typeTransaction}
                                closeMenuOnSelect={true}
                                onChange={this.setArticleFilters('typeTransaction')}
                                options={[
                                    {value: null, label: 'Оба типа'},
                                    {value: 'cash', label: 'Наличные'},
                                    {value: 'noncash', label: 'Безнал. '}
                                ]}
                                placeholder="Тип транзакции"
                                noOptionsMessage={() => 'Нет типов'}
                                />
                            </div>
                            <div style={{ width: 150 }}>
                                <Select
                                isLoading={this.props.loadingArticles || this.props.loadingFilials}
                                isDisabled={this.props.loadingArticles || this.props.loadingFilials}
                                value={this.state.articlesFilters.typeMovementCash}
                                closeMenuOnSelect={true}
                                onChange={this.setArticleFilters('typeMovementCash')}
                                options={[
                                    {value: null, label: 'Все'},
                                    ...optionsMovementCash
                                ]}
                                placeholder="Тип"
                                noOptionsMessage={() => 'Нет типов'}
                                />
                            </div>
                        </>
                    }
                    {(window.innerWidth > 1024 || this.props.UImobile.openFilters) &&
                    <div className='dateBlock'>
                        <DateInput
                            placeholderText="Дата c"
                            selected={this.props.filters.createdStartDate}
                            onChange={this.onChangeDateInput('createdStartDate')}
                            required={this.props.filters.createdEndDate}
                        />
                        <div>-</div>
                        <DateInput
                            placeholderText="Дата по"
                            selected={this.props.filters.createdEndDate}
                            onChange={this.onChangeDateInput('createdEndDate')}
                            required={this.props.filters.createdStartDate}
                        />
                        {
                            this.props.filters.createdStartDate && this.props.filters.createdEndDate &&
                            <div>
                                <button
                                    className={`btn ${(this.props.list && this.props.list.length > 0) ? 'btn-danger' : 'btn-success'} btn-icon`}
                                    style={{ height: '2.5rem', width: '2.5rem' }}
                                    onClick={this.onSearchDate}
                                >
                                    <i className={(this.props.list && this.props.list.length > 0) ? 'flaticon2-cross' : 'flaticon2-check-mark'}/>
                                </button>
                            </div>
                        }
                    </div>
                    }
                    {this.props.filters.createdStartDate && this.props.filters.createdEndDate && this.props.list && this.props.list.length > 0 &&
                        <>
                            <button onClick={this.onExportBalance} className='btn btn-dark btn-sm' style={{ height: '2.5rem' }}>
                                Экспорт балансов
                            </button>
                            <button onClick={this.onExportArticles} className='btn btn-dark btn-sm' style={{ height: '2.5rem' }}>
                                Экспорт операций
                            </button>
                        </>
                    }
            </div>
            );
    }

    renderInfoworkingShift() {
        const shift = this.props.workingShift;
        const { revenue } = this.state;
        const { unfiscalized } = this.state;
        const isTruncated = unfiscalized.map(item => item.id).join(', ').length > 12
        const cashUnfiscalized = (unfiscalized || []).filter(
            order => order.payment === 'cash'
        );
        const terminalUnfiscalized = (unfiscalized || []).filter(
            order => order.payment === 'terminal'
        );

        if(window.innerWidth <= 750)
            return(
                <div className='workingShift_row' style={{ padding: '0px', width: '100%' }}>
                    <div className='workingShift_cell' style={{ flexDirection: 'column', flex: 1 }}>
                        <span style={{ fontWeight: 600}}> Наличные </span>
                        <span>{`Нач. ост. ${shift.initialBalanceCash ? parseFloat(shift.initialBalanceCash).toFixed(2) : '0.00'}`}</span>
                        <span>{`Выручка ${(shift.revenueCash != null && shift.closed_at != null) ? shift.revenueCash : revenue.cash}`}</span>
                        <span>{`Внесено ${shift.depositingCash ? parseFloat(shift.depositingCash).toFixed(2) : '0.00'}`}</span>
                        {/* {<span>{`Инкассировано ${shift.incassoCash ? parseFloat(shift.incassoCash).toFixed(2) : '0.00'}`}</span>} */}
                        <span>{`Изъято ${shift.withdrawalCash ? parseFloat(shift.withdrawalCash).toFixed(2) : '0.00'}`}</span>
                        <span>{`Итого ${this.renderFinalBalanceOpenedShift('cash')}`}</span>
                    </div>
                    <div className='workingShift_cell' style={{ flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
                        <div className='ws_column'>
                            <span style={{ fontWeight: 600}}> Счет </span>
                            <span>{`Нач. ост. ${shift.initialBalanceNoncash ? parseFloat(shift.initialBalanceNoncash).toFixed(2) : '0.00'}`}</span>
                            <span>{`Выручка ${(shift.revenueNoncash != null && shift.closed_at != null) ? shift.revenueNoncash : revenue.noncash}`}</span>
                            <span>{`Внесено ${shift.depositingNoncash ? parseFloat(shift.depositingNoncash).toFixed(2) : '0.00'}`}</span>
                        </div>
                        <div className='ws_column'>
                            <span>{`Изъято ${shift.withdrawalNoncash ? parseFloat(shift.withdrawalNoncash).toFixed(2) : '0.00'}`}</span>
                            <span>{`Итого ${this.renderFinalBalanceOpenedShift('noncash')}`}</span>
                        </div>
                    </div>
                    {unfiscalized.length > 0 && 
                        <div className="workingShift_cell workingShift_cell--mobile-warning" style={{outline: '1px solid red', display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '8px', padding: '12px', borderRadius: '8px'}}>
                            <div style={{position:'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap:'10px' }}>
                                <span style={{ fontWeight: 600, color: 'red' }}>
                                    Заказов без фискализации: {unfiscalized.length} 
                                </span>
                                <button 
                                className="order_position_list_inf_button"
                                onClick={(() => this.setState({openDescription : 'Номера заказов: ' + unfiscalized.map(item => item.id).join(', ')}))}
                                onBlur={(() => this.setState({openDescription : false}))}
                                >
                                    i
                                </button>
                                {this.state.openDescription !== false && <span style={{position:'absolute', top: '100%', marginTop:'8px', backgroundColor:'#ffffff', border: '1px solid #cccccc'}}>{this.state.openDescription}</span>}
                            </div>
                            <div style={{ display: 'flex', gap: '16px', marginTop: '4px', fontSize: '13px' }}>
                                <span style={{ color: 'red' }}>Наличные: {cashUnfiscalized.length}</span>
                                <span style={{ color: 'red' }}>Безнал: {terminalUnfiscalized.length}</span>
                            </div>
                        </div>
                    }                    
                </div>
            );
        
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px'}}>
                <div className="workingShift_cell">
                    <div className='ws_column'>
                        <span style={{ fontWeight: 600}}> Наличные </span>
                        <span style={{ fontWeight: 600}}> Счет </span>
                    </div>
                    <div className='ws_column'>
                        <span>{`Нач. ост. ${shift.initialBalanceCash ? parseFloat(shift.initialBalanceCash).toFixed(2) : '0.00'}`}</span>
                        <span>{`Нач. ост. ${shift.initialBalanceNoncash ? parseFloat(shift.initialBalanceNoncash).toFixed(2) : '0.00'}`}</span>
                    </div>
                    <div className='ws_column'>
                        <span>{`Выручка ${(shift.revenueCash && shift.closed_at != null) ? shift.revenueCash : revenue.cash}`}</span>
                        <span>{`Выручка ${(shift.revenueNoncash && shift.closed_at != null) ? shift.revenueNoncash : revenue.noncash}`}</span>
                    </div>
                    <div className='ws_column'>
                        <span>{`Внесено ${shift.depositingCash ? parseFloat(shift.depositingCash).toFixed(2) : '0.00'}`}</span>
                        <span>{`Внесено ${shift.depositingNoncash ? parseFloat(shift.depositingNoncash).toFixed(2) : '0.00'}`}</span>
                    </div>
                    {/*<div className='ws_column'>
                        <span>{`Инкассировано ${shift.incassoCash ? parseFloat(shift.incassoCash).toFixed(2) : '0.00'}`}</span>
                    </div>*/}
                    <div className='ws_column'>
                        <span>{`Изъято ${shift.withdrawalCash ? parseFloat(shift.withdrawalCash).toFixed(2) : '0.00'}`}</span>
                        <span>{`Изъято ${shift.withdrawalNoncash ? parseFloat(shift.withdrawalNoncash).toFixed(2) : '0.00'}`}</span>
                    </div>
                    <div className='ws_column'>
                        <span>{`Итого ${this.renderFinalBalanceOpenedShift('cash')}`}</span>
                        <span>{`Итого ${this.renderFinalBalanceOpenedShift('noncash')}`}</span>
                    </div>
                </div>
                { unfiscalized.length > 0 && <div className="workingShift_cell" style={{ outline: '1px solid red', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div className='ws_column'>
                        <span style={{ fontWeight: 600, color: 'red' }}> Кол-во заказов без фискализации: {unfiscalized.length} </span>
                        <div style={{ display: 'flex', position: 'relative'}} >
                            <span style={{ fontWeight: 600, color: 'red', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '200px', display: 'inline-block'}}> Номера заказов: {unfiscalized.map(item => item.id).join(', ')} </span>
                            {isTruncated && <button 
                            className="order_position_list_inf_button"
                            onClick={(() => this.setState({openDescription : 'Номера заказов: ' + unfiscalized.map(item => item.id).join(', ')}))}
                            onBlur={(() => this.setState({openDescription : false}))}
                            >
                                i
                            </button>}
                            {this.state.openDescription !== false && <span style={{position:'absolute', top: '100%', marginTop:'8px', backgroundColor:'#ffffff', border: '1px solid #cccccc'}}>{this.state.openDescription}</span>}
                        </div>
                        
                    </div>
                    <div className='ws_column'>
                        <span style={{ color: 'red' }}> Наличные: </span>
                        <span style={{ color: 'red' }}> Безнал: </span>
                    </div>
                    <div className='ws_column'>
                        <span style={{ color: 'red' }}> {cashUnfiscalized.length}  </span>
                        <span style={{ color: 'red' }}> {terminalUnfiscalized.length} </span>
                    </div>
                </div>}
            </div>    
        );
    }

    renderHead() {
        const shift = this.props.workingShift;

        if(!shift) {
            return (
            <div className="workingShift_row">
                Смен нет
            </div>
            );
        }
        
        if(shift.closed_at != null) {            
            return (
            <div className="workingShift_row">
                <div className="workingShift_cell">
                    {`Смена закрыта: ${moment(shift.closed_at).format('DD.MM.YYYY HH:mm:ss')} ${shift.shiftCloser ? shift.shiftCloser : ''}`}
                </div>
                <div className="workingShift_cell">
                    {`В кассе: ${shift.finalBalanceCash ? parseNumToFixed(shift.finalBalanceCash).toFixed(2) : '0'}`}
                </div>
                <div className="workingShift_cell">
                    {`На счету: ${shift.finalBalanceNoncash ? parseNumToFixed(shift.finalBalanceNoncash) : '0'}`}
                </div>
                <div className="workingShift_cell">
                    {`Выручка наличные: ${shift.revenueCash ? parseNumToFixed(shift.revenueCash).toFixed(2) : '0'}`}
                </div>
                <div className="workingShift_cell">
                    {`Выручка терминал: ${shift.revenueNoncash ? parseNumToFixed(shift.revenueNoncash) : '0'}`}
                </div>
            </div>
            );
        }

        return (
            <div className="workingShift_row">
                <div className="workingShift_cell">
                    <div className='ws_column'>
                        <span>{`Открыта: ${moment(shift.opened_at).format('DD.MM.YYYY HH:mm:ss')}`}</span>
                        <span>{shift.shiftOpener ? `Открыл: ${shift.shiftOpener}` : ''}</span>
                    </div>
                </div>
                {this.renderInfoworkingShift()}
            </div>
        );
    }

    renderTable() {
        const { list, workingShift, role } = this.props;
        const isListEmpty = !list || list.length === 0;

        if (workingShift && !workingShift.closed_at && isListEmpty) {
            return (
                <ErrorBoundary fallback={<tbody className="kt-datatable__body">{`Не удалось отобразить статьи. Попробуйте позже.`}</tbody>}>
                    <WorkingShiftArticlesTable
                        items={workingShift.articlesCashes || []}
                        filters={this.state.articlesFilters}
                        onEditArticle={this.onEditArticle}
                        deleteArticle={this.deleteArticle}
                    />
                </ErrorBoundary>
            );
        }

        if (list && list.length > 0) {
            return (
                <ErrorBoundary fallback={<tbody className="kt-datatable__body">{`Не удалось отобразить смены. Попробуйте позже.`}</tbody>}>
                    <WorkingShiftsTable
                        onDelete={this.onDelete}
                        onRecalculation={this.onRecalculation}
                        items={list}
                        role={role}
                        onEditArticle={this.onEditArticle}
                        setWorkingShift={this.props.setWorkingShift}
                        setActiveModalAction={this.props.setActiveModalAction}
                    />
                </ErrorBoundary>
            );
        }
    }

    render() {
        if (this.props.loading || this.state.loadingRevenue) {
            return (
                <div style={styles.loading}><Loader /></div>
            );
        }

        const actionsMobile =[
            { active: true, name: (this.props.workingShift && !this.props.workingShift.closed_at) ? 'Закрыть смену' : 'Открыть смену', action: () => this.onOpenModal() },
            { active: (this.props.workingShift && !this.props.workingShift.closed_at), name: '+ Внесение', action: () => this.onAddArticle('income') },
            // { active: (this.props.workingShift && !this.props.workingShift.closed_at), name: 'Инкассация', action: () => this.onAddArticle('incasso') },
            { active: (this.props.workingShift && !this.props.workingShift.closed_at), name: '- Изъятие', action: () => this.onAddArticle('expenditure') }
        ].filter(item => (!item.access || item.access.includes(this.props.role)) && item.active );   
        
        return (
            <Fragment>
                {actionsMobile.length > 0 && <HeadMobileActionMenu actions={actionsMobile}/>}
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div className="kt-portlet__body">
                        <div className="kt-form kt-form--label-right kt-margin-b-10">
                            {this.renderFiltersBlock()}
                        </div>
                    </div>
                <Portlet fit={true}>
                    <ErrorContainer field="workingShift" style={{ margin: 15 }} hasCloseButton={true}/>
                    <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
                        {(!this.props.list || this.props.list.length === 0) && this.renderHead()}
                        {this.renderTable()}
                    </div>
                </Portlet>
            </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    filters: state.cassa.filters,
    loading: state.loaders.workingShift,
    workingShift: state.cassa.workingShift,
    list: state.cassa.list,
    articlesCash: state.handbook.articlesCash,
    role: state.user.info.role.id,
    loadingArticles: state.loaders.articlesCash,
    loadingFilials: state.loaders.filials,
    filials: state.handbook.filials,
    UImobile: state.UImobile,
});

const mapDispatchToProps = {
    fetchFilials: (city) => fetchFilials(city, true),
    fetchArticlesCash: (isGetAll) => fetchArticlesCash(isGetAll),
    fetchWorkingShift: () => fetchWorkingShift(),
    setCassaFilters: (filters) => setCassaFilters(filters),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton),
    setActiveModalAction: (value) => setActiveModalAction(value),
    setTypeMovementCash: (type) => setTypeMovementCash(type),
    getXReport: (point) => getXReport(point),
    setDetailArticle: (article) => setDetailArticle(article),
    deleteArticleWorkingShift: (article) => deleteArticleWorkingShift(article),
    setWorkingShift: (data) => setWorkingShift(data),
    initLMMark: (point) => initLMMark(point),
    getStatusLM: (point) => getStatusLM(point),
    deleteWorkingShift: (id) => deleteWorkingShift(id),
    recalculationWorkingShift: (item) => recalculationWorkingShift(item),
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkingShiftList);